<template>
  <div id="box">
    <div class="historyTag">
      <historyTag :historyArr="historyArr"></historyTag>
    </div>

    <div class="topBox flex">
      <div class="topLeft flex filterBar">
        <div class="filterItem">
          <span class="filterLabel">参与用户</span>
          <el-input
            v-model="query.userId"
            placeholder="任一方，可选"
            clearable
            class="filterInput filterInput--sm"
            @keyup.enter.native="searchFn"
          />
        </div>
        <div class="filterItem">
          <span class="filterLabel">商品</span>
          <el-input
            v-model="query.productId"
            placeholder="可选"
            clearable
            class="filterInput filterInput--sm"
            @keyup.enter.native="searchFn"
          />
        </div>
        <div class="filterItem">
          <span class="filterLabel">订单</span>
          <el-input
            v-model="query.orderNo"
            placeholder="订单号或ID"
            clearable
            class="filterInput filterInput--md"
            @keyup.enter.native="searchFn"
          />
        </div>
        <div class="filterItem">
          <span class="filterLabel">昵称</span>
          <el-input
            v-model="query.keyword"
            placeholder="买卖双方昵称"
            clearable
            class="filterInput filterInput--md"
            @keyup.enter.native="searchFn"
          />
        </div>
        <el-button type="success" size="small" @click="searchFn">搜索</el-button>
        <el-button size="small" @click="resetFn">重置</el-button>
      </div>
    </div>

    <div class="table-scroll-wrap">
    <el-table :data="tableData" border class="convTable" v-loading="loading">
      <el-table-column label="买家" min-width="140">
        <template slot-scope="scope">
          <div class="participant">
            <img
              v-if="scope.row.buyerPhoto"
              :src="scope.row.buyerPhoto"
              class="pAvatar"
              alt=""
            />
            <div v-else class="pAvatar pAvatar--ph">{{ initialChar(scope.row.buyerNickName) }}</div>
            <span class="pName">{{ scope.row.buyerNickName || "—" }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="卖家" min-width="140">
        <template slot-scope="scope">
          <div class="participant">
            <img
              v-if="scope.row.sellerPhoto"
              :src="scope.row.sellerPhoto"
              class="pAvatar"
              alt=""
            />
            <div v-else class="pAvatar pAvatar--ph">{{ initialChar(scope.row.sellerNickName) }}</div>
            <span class="pName">{{ scope.row.sellerNickName || "—" }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="咨询商品" min-width="220" class-name="cell-title-wrap">
        <template slot-scope="scope">
          <div v-if="scope.row.productId && scope.row.productId > 0" class="productCell">
            <el-image
              v-if="scope.row.productImage"
              class="productThumb"
              :src="scope.row.productImage | assetUrl"
              fit="cover"
              :preview-src-list="[scope.row.productImage | assetUrl]"
            />
            <div v-else class="productThumb productThumb--empty">无图</div>
            <span class="productTitle">{{ scope.row.productTitle || "—" }}</span>
          </div>
          <span v-else class="muted">未关联商品</span>
        </template>
      </el-table-column>
      <el-table-column label="关联订单" min-width="200" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.orderNo" class="orderNo">{{ scope.row.orderNo }}</span>
          <span v-else class="muted">暂无订单</span>
        </template>
      </el-table-column>
      <el-table-column label="最近活跃" width="168" align="center">
        <template slot-scope="scope">{{ formatTime(scope.row.lastMessageTime || scope.row.createTime) }}</template>
      </el-table-column>
      <el-table-column label="操作" width="112" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" plain @click="openMessages(scope.row)">查看记录</el-button>
        </template>
      </el-table-column>
    </el-table>
    </div>

    <list-pagination
      :total="tableTotal"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      @page-change="changePage"
      @size-change="handlePageSizeChange"
    />

    <el-dialog
      :title="dialogTitle"
      :visible.sync="msgDialogVisible"
      width="460px"
      custom-class="chatRecordDialog"
      top="6vh"
      @closed="onMsgDialogClosed"
    >
      <div v-if="currentConv" class="chatSheet">
        <div class="chatHead">
          <div class="chatHeadRow">
            <span class="roleLabel">买家</span>
            <span class="chatHeadName">{{ currentConv.buyerNickName || "—" }}</span>
          </div>
          <div class="chatHeadRow">
            <span class="roleLabel">卖家</span>
            <span class="chatHeadName">{{ currentConv.sellerNickName || "—" }}</span>
          </div>
          <div v-if="currentConv.productTitle" class="chatHeadSub">商品：{{ currentConv.productTitle }}</div>
          <div v-if="currentConv.orderNo" class="chatHeadSub">订单：{{ currentConv.orderNo }}</div>
        </div>

        <div
          ref="bubbleScroll"
          class="bubbleScroll"
          @scroll.passive="onBubbleScroll"
        >
          <div v-if="msgTotal > 0 || msgLoadingOlder" class="loadOlderBar">
            <span v-if="msgLoadingOlder">加载更早的消息…</span>
            <span v-else-if="hasMoreOlder">上滑至顶部加载更多记录</span>
            <span v-else class="mutedSmall">已显示全部消息</span>
          </div>

          <div v-if="msgLoading && !msgList.length" class="bubbleEmpty">加载中…</div>
          <div v-else-if="!msgList.length" class="bubbleEmpty">暂无消息</div>

          <div
            v-for="m in msgList"
            :key="'m' + m.id"
            class="bubbleRow"
            :class="bubbleRowClass(m)"
          >
            <div class="bubbleSide">
              <img
                v-if="m.senderPhoto"
                :src="m.senderPhoto"
                class="bubbleAvatar"
                alt=""
              />
              <div v-else class="bubbleAvatar bubbleAvatar--ph">{{ initialChar(m.senderNickName) }}</div>
            </div>
            <div class="bubbleMain">
              <div class="bubbleMeta">
                <span class="bubbleRole">{{ isSellerMessage(m) ? "卖家" : "买家" }}</span>
                <span class="bubbleNick">{{ m.senderNickName || "—" }}</span>
                <span class="bubbleTime">{{ formatTime(m.createTime) }}</span>
              </div>
              <!-- 闲置订单状态卡片（紫底白字，与小程序一致） -->
              <div v-if="isSecondhandOrderCard(m)" class="orderCardWrap">
                <div class="orderCard">
                  <div class="orderCardTitle">{{ orderCardTitle(m) }}</div>
                  <div v-if="orderCardSubtitle(m)" class="orderCardSub">{{ orderCardSubtitle(m) }}</div>
                </div>
                <div
                  v-if="m.isRead === 1 || m.readFlag === 1 || m.readStatus === 1"
                  class="orderCardRead"
                >
                  已读
                </div>
              </div>
              <div v-else class="bubbleContent">
                <el-image
                  v-if="isImageMessage(m) && m.content"
                  class="bubbleImg"
                  :src="m.content"
                  fit="cover"
                  :preview-src-list="[m.content]"
                />
                <span v-else class="bubbleText">{{ m.content || "—" }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <span slot="footer">
        <el-button size="small" @click="msgDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { returnTime } from "@/util/utils";

/**
 * 与后端约定：msgType=3 为闲置「交易状态卡片」，content 为 JSON 字符串；
 * 或 msgType=1 且 content 为含 cardType/kind/title 的 JSON。
 * 例（买家拍下待付款）：{"title":"我已拍下，待付款","subtitle":"请双方沟通及时确认价格"}
 */
const MSG_TYPE_SECONDHAND_ORDER_CARD = 3;

export default {
  data() {
    return {
      historyArr: ["买卖家聊天", "闲置聊天管理"],
      loading: false,
      query: {
        userId: "",
        productId: "",
        orderNo: "",
        keyword: "",
      },
      tableData: [],
      pageSize: 50,
      currentPage: 1,
      tableTotal: 0,

      msgDialogVisible: false,
      msgLoading: false,
      msgLoadingOlder: false,
      currentConv: null,
      msgList: [],
      msgPageSize: 30,
      msgTotal: 0,
      nextOlderPage: 2,
      hasMoreOlder: false,
      scrollLockLoad: false,
    };
  },

  computed: {
    dialogTitle() {
      if (!this.currentConv) return "聊天记录";
      const b = this.currentConv.buyerNickName || "买家";
      const s = this.currentConv.sellerNickName || "卖家";
      return `${b} · ${s}`;
    },
  },

  mounted() {
    this.fetchList(1);
  },

  methods: {
    initialChar(name) {
      const s = String(name || "").trim();
      return s ? s.charAt(0) : "?";
    },

    isSellerMessage(m) {
      if (!m || !this.currentConv || this.currentConv.sellerUserId == null) return false;
      return m.senderUserId === this.currentConv.sellerUserId;
    },

    bubbleRowClass(m) {
      if (this.isSecondhandOrderCard(m)) {
        return {
          "bubbleRow--seller": this.isSellerMessage(m),
          "bubbleRow--buyerOrderCard": !this.isSellerMessage(m),
          "bubbleRow--orderCard": true,
        };
      }
      return {
        "bubbleRow--seller": this.isSellerMessage(m),
      };
    },

    safeParseJson(s) {
      if (s == null || s === "") return null;
      const str = String(s).trim();
      if (!str.startsWith("{") && !str.startsWith("[")) return null;
      try {
        return JSON.parse(str);
      } catch (e) {
        return null;
      }
    },

    /** 接口里 msgType 可能是数字或字符串 "3"，统一成数字再比较 */
    normalizeMsgType(m) {
      if (!m || m.msgType == null || m.msgType === "") return null;
      const n = Number(m.msgType);
      return Number.isNaN(n) ? null : n;
    },

    isImageMessage(m) {
      return this.normalizeMsgType(m) === 2;
    },

    /** content 可能是 JSON 字符串，或已被反序列化成对象 */
    parseContentAsOrderCardObject(content) {
      if (content == null) return null;
      if (typeof content === "object" && !Array.isArray(content)) {
        return content;
      }
      return this.safeParseJson(content);
    },

    parseOrderCardPayload(m) {
      if (!m) return null;
      const mt = this.normalizeMsgType(m);
      const o = this.parseContentAsOrderCardObject(m.content);
      if (!o || typeof o !== "object") return null;

      if (mt === MSG_TYPE_SECONDHAND_ORDER_CARD) {
        return o;
      }
      if (mt === 1) {
        if (o.cardType === "secondhand_order" || o.kind === "secondhand_order") return o;
        if (o.title && (o.subtitle != null || o.subTitle != null || o.desc != null)) return o;
      }
      // 兼容：msgType 丢失/被转成字符串导致未命中上面分支，但 content 已是闲置卡片 JSON
      if (o.cardType === "secondhand_order" || o.kind === "secondhand_order") {
        return o;
      }
      return null;
    },

    isSecondhandOrderCard(m) {
      return !!this.parseOrderCardPayload(m);
    },

    orderCardTitle(m) {
      const o = this.parseOrderCardPayload(m);
      if (!o) return "";
      return o.title || o.headline || "—";
    },

    orderCardSubtitle(m) {
      const o = this.parseOrderCardPayload(m);
      if (!o) return "";
      const sub =
        o.subtitle != null ? o.subtitle : o.subTitle != null ? o.subTitle : o.desc;
      return sub != null ? String(sub) : "";
    },

    formatTime(t) {
      if (!t) return "-";
      try {
        return returnTime(t, "-", "s");
      } catch (e) {
        return String(t);
      }
    },

    parseIntOrNull(v) {
      const s = String(v == null ? "" : v).trim();
      if (!s) return null;
      const n = parseInt(s, 10);
      return Number.isNaN(n) ? null : n;
    },

    resetFn() {
      this.query = { userId: "", productId: "", orderNo: "", keyword: "" };
      this.currentPage = 1;
      this.fetchList(1);
    },

    searchFn() {
      this.currentPage = 1;
      this.fetchList(1);
    },

    changePage(p) {
      this.fetchList(p);
    },

    handlePageSizeChange() {
      this.fetchList(this.currentPage);
    },

    fetchList(page) {
      this.loading = true;
      const obj = {
        page: page || 1,
        size: this.pageSize,
      };
      const uid = this.parseIntOrNull(this.query.userId);
      const pid = this.parseIntOrNull(this.query.productId);
      const orderRaw = String(this.query.orderNo || "").trim();
      const kw = String(this.query.keyword || "").trim();
      if (uid != null) obj.userId = uid;
      if (pid != null) obj.productId = pid;
      if (orderRaw) obj.orderNo = orderRaw;
      if (kw) obj.keyword = kw;

      this.$axios
        .post(this.$api.api.selMgmtChatConversation, obj, {
          headers: { "Content-Type": "application/json;charset=UTF-8" },
        })
        .then((res) => {
          const body = res && res.data;
          if (body && body.code == 200) {
            this.tableData = Array.isArray(body.data) ? body.data : [];
            this.tableTotal = body.size || 0;
          } else {
            this.tableData = [];
            this.tableTotal = 0;
            this.$message.error((body && body.msg) || "查询失败");
          }
        })
        .catch((err) => {
          this.tableData = [];
          this.tableTotal = 0;
          const msg =
            (err &&
              err.response &&
              err.response.data &&
              (err.response.data.msg || err.response.data.message)) ||
            "查询失败";
          this.$message.error(msg);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    openMessages(row) {
      if (!row || !row.id) return;
      this.currentConv = row;
      this.msgDialogVisible = true;
      this.msgList = [];
      this.msgTotal = 0;
      this.nextOlderPage = 2;
      this.hasMoreOlder = false;
      this.scrollLockLoad = false;
      this.fetchMessages(1, true);
    },

    onMsgDialogClosed() {
      this.currentConv = null;
      this.msgList = [];
      this.msgTotal = 0;
      this.msgLoading = false;
      this.msgLoadingOlder = false;
    },

    fetchMessages(page, isInitial) {
      if (!this.currentConv) return;
      if (isInitial) {
        this.msgLoading = true;
      } else {
        this.msgLoadingOlder = true;
      }
      this.$https(this.$api.api.selMgmtChatMessages, {
        conversationId: this.currentConv.id,
        page: page || 1,
        size: this.msgPageSize,
      }, "GET")
        .then((res) => {
          if (res.data && res.data.code == 200) {
            const raw = res.data.data || [];
            this.msgTotal = res.data.size || 0;
            const chunk = raw.slice().reverse();
            if (isInitial) {
              this.msgList = chunk;
              this.nextOlderPage = 2;
              this.hasMoreOlder = this.msgList.length < this.msgTotal;
              this.$nextTick(() => {
                this.scrollChatToBottom();
              });
            } else {
              const el = this.$refs.bubbleScroll;
              const prevH = el ? el.scrollHeight : 0;
              const prevTop = el ? el.scrollTop : 0;
              this.msgList = chunk.concat(this.msgList);
              this.nextOlderPage = (page || 1) + 1;
              this.hasMoreOlder = this.msgList.length < this.msgTotal;
              this.$nextTick(() => {
                if (el) {
                  el.scrollTop = el.scrollHeight - prevH + prevTop;
                }
              });
            }
          } else {
            if (isInitial) {
              this.msgList = [];
            }
            this.$message.error((res.data && res.data.msg) || "加载消息失败");
          }
        })
        .catch(() => {
          if (isInitial) {
            this.msgList = [];
          }
          this.$message.error("加载消息失败");
        })
        .finally(() => {
          this.msgLoading = false;
          this.msgLoadingOlder = false;
          this.scrollLockLoad = false;
        });
    },

    scrollChatToBottom() {
      const el = this.$refs.bubbleScroll;
      if (!el) return;
      this.$nextTick(() => {
        el.scrollTop = el.scrollHeight;
      });
    },

    onBubbleScroll(e) {
      const el = e.target;
      if (!el || this.msgLoading || this.msgLoadingOlder || this.scrollLockLoad) return;
      if (!this.hasMoreOlder) return;
      if (el.scrollTop <= 48) {
        this.scrollLockLoad = true;
        this.fetchMessages(this.nextOlderPage, false);
      }
    },

  },
};
</script>

<style lang="less" scoped>
#box {
  width: 100%;
}

.filterBar {
  align-items: center;
  flex-wrap: wrap;
}

.filterItem {
  display: flex;
  align-items: center;
  margin-right: 12px;
  margin-bottom: 6px;
}

.filterLabel {
  white-space: nowrap;
  margin-right: 8px;
  font-size: 13px;
  color: #606266;
}

.filterInput--sm {
  width: 132px;
}

.filterInput--md {
  width: 168px;
}

.convTable {
  width: 100%;
  margin-top: 12px;
}

.participant {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.pAvatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;

  &--ph {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #ebeef5;
    color: #909399;
    font-size: 14px;
  }
}

.pName {
  font-size: 13px;
  color: #303133;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 140px;
}

.productCell {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  min-width: 0;
}

.productThumb {
  width: 44px;
  height: 44px;
  border-radius: 6px;
  flex-shrink: 0;

  &--empty {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f5f7fa;
    color: #c0c4cc;
    font-size: 12px;
  }
}

.productTitle {
  font-size: 13px;
  line-height: 1.4;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
}

.muted {
  color: #c0c4cc;
  font-size: 13px;
}

.orderNo {
  font-size: 13px;
  color: #303133;
  word-break: break-all;
}

.chatSheet {
  margin: -8px -12px 0;
}

.chatHead {
  padding: 0 12px 12px;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 0;
  background: #fff;
}

.chatHeadRow {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 6px;
  font-size: 14px;
}

.roleLabel {
  flex-shrink: 0;
  width: 40px;
  color: #909399;
  font-size: 13px;
}

.chatHeadName {
  color: #303133;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.chatHeadSub {
  font-size: 12px;
  color: #606266;
  margin-top: 4px;
  line-height: 1.4;
  word-break: break-word;
}

.bubbleScroll {
  height: ~"min(62vh, 520px)";
  overflow-x: hidden;
  overflow-y: auto;
  padding: 12px 12px 16px;
  background: #f0f2f5
    url("data:image/svg+xml,%3Csvg width='12' height='12' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='2' cy='2' r='1' fill='%23d0d5e0'/%3E%3C/svg%3E")
    repeat;
  background-size: 12px 12px;
}

.loadOlderBar {
  text-align: center;
  font-size: 12px;
  color: #909399;
  padding: 8px 0 12px;
  user-select: none;
}

.mutedSmall {
  color: #c0c4cc;
  font-size: 12px;
}

.bubbleEmpty {
  text-align: center;
  color: #909399;
  padding: 40px 0;
  font-size: 14px;
}

.bubbleRow {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 12px;

  &--seller {
    flex-direction: row-reverse;

    .bubbleMain {
      align-items: flex-end;
    }

    .bubbleMeta {
      flex-direction: row-reverse;
    }

    .bubbleContent {
      background: #95ec69;
      border-color: #8ad862;
    }
  }

  /* 买家侧交易状态卡片：头像在右、卡片靠右 */
  &--buyerOrderCard {
    flex-direction: row-reverse;

    .bubbleMain {
      align-items: flex-end;
    }

    .bubbleMeta {
      flex-direction: row-reverse;
    }
  }

  &--orderCard {
    .bubbleMain {
      max-width: 92%;
    }
  }
}

.orderCardWrap {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  min-width: 0;
  max-width: 100%;
}

.orderCard {
  padding: 14px 16px;
  border-radius: 14px;
  min-width: 220px;
  max-width: 360px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
  text-align: left;
}

.bubbleRow--orderCard .orderCard {
  background: linear-gradient(135deg, #2e1a39 0%, #3d2547 100%);
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: 0 4px 14px rgba(46, 26, 57, 0.35);
}

.orderCardTitle {
  font-size: 17px;
  font-weight: 600;
  color: #fff;
  line-height: 1.35;
}

.orderCardSub {
  margin-top: 8px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.82);
  line-height: 1.45;
}

.orderCardRead {
  margin-top: 2px;
  font-size: 11px;
  color: #c0c4cc;
  padding-right: 2px;
}

.bubbleSide {
  flex-shrink: 0;
}

.bubbleAvatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  object-fit: cover;

  &--ph {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #e4e6eb;
    color: #909399;
    font-size: 13px;
  }
}

.bubbleMain {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 0;
  max-width: 82%;
}

.bubbleMeta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 4px;
  font-size: 11px;
}

.bubbleRole {
  color: #909399;
}

.bubbleNick {
  color: #606266;
  font-weight: 500;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.bubbleTime {
  color: #c0c4cc;
}

.bubbleContent {
  padding: 8px 11px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 4px 12px 12px 12px;
  word-break: break-word;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.04);
}

.bubbleRow--seller .bubbleContent {
  border-radius: 12px 4px 12px 12px;
}

.bubbleText {
  font-size: 14px;
  color: #303133;
  line-height: 1.45;
}

.bubbleImg {
  max-width: 200px;
  max-height: 200px;
  border-radius: 8px;
  display: block;
}

.page_box {
  margin-top: 12px;
}
</style>

<style lang="less">
/* 聊天弹窗：不加 scoped，避免 custom-class 无法命中 */
.chatRecordDialog {
  .el-dialog__body {
    padding: 12px 12px 8px;
    background: #f5f7fa;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/chatRecord/index.vue